






























import Vue from 'vue';
import { Campaign, User } from '@/types';

interface Data {
    campaigns: Record<number, Campaign>;
    user?: User;
    userCampaigns: number[];
}

export default Vue.extend({
    data(): Data {
        return {
            campaigns: {},
            user: undefined,
            userCampaigns: [],
        };
    },
    computed: {
        displayCampaigns(): Campaign[] {
            return Object.keys(this.campaigns)
                .filter(campId => this.userCampaigns.includes(parseInt(campId)))
                .map(id => {
                    return this.campaigns[id];
                })
                .sort((a, b) => a.title.localeCompare(b.title));
        },
    },
    methods: {
        beforeOpen(e) {
            this.campaigns = e.params.campaigns;
            this.user = e.params.user;
            this.userCampaigns = e.params.user.campaignIds;
        },
    },
});
